import { Utilities } from "@itm/constants/utilities";
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

type DynamicFormState = {
    toolbarProps: any;
    formData: any;
    entityId: string;
    componentNullable: any,
    buttonClickHandler: any;
};

const initialFormState: DynamicFormState = {
    toolbarProps: undefined,
    formData: undefined,
    buttonClickHandler: undefined,
    componentNullable: null,
    entityId: undefined,
};

export const DynamicFormStore = signalStore(
    { providedIn: 'root' },
    withState(initialFormState),
    // 👇 Accessing a store instance with previously defined state signals,
    // properties, and methods.
    withMethods((store) => ({
        setToolbarProps(props: any): void {
            patchState(store, (state) => ({ toolbarProps: { ...state.toolbarProps, props } }));
        },
        setButtonClickHandler(props: any): void {
            patchState(store, (state) => ({ buttonClickHandler: props }));
        },
        setComponentNullable(props: any): void {
            patchState(store, (state) => ({ componentNullable: props }));
        },
        setEntityId(entityId: string): void {
            patchState(store, (state) => ({ entityId: entityId }));
        },
        setFormData(formData: any): void {
            patchState(store, (state) => ({ formData: formData }));
        },
        patchFormData(newData: any): void {
            patchState(store, (state) => ({ formData: { ...state.formData, "newData": newData } }));
        },
        updateTreeViewFormData(newData: any): void {
            patchState(store, (state) => ({ formData: { ...state.formData, "treeView": newData } }));
        },
        updateRolesFormData(newData: any): void {
            patchState(store, (state) => ({ formData: { ...state.formData, "roles": newData } }));
        },
    }))
);
